/**
 * detailRowMemo — LUẬT QUYẾT ĐỊNH MỘT DÒNG CHI TIẾT CÓ PHẢI VẼ LẠI HAY KHÔNG.
 *
 * Tách khỏi ObjectArrayControl.jsx để (1) đọc được luật ở một chỗ và (2) chốt được bằng test chạy
 * trong node (file này KHÔNG import gì, không JSX).
 *
 * Bối cảnh: trong bố cục chứng từ, `masterData` (toàn bộ bản ghi cha) đổi THAM CHIẾU mỗi lần gõ phím ở
 * bất kỳ ô nào — kể cả ô trên phần master. Nếu dòng chi tiết cứ thế vẽ lại theo thì với 30 dòng × 3 cột
 * autocomplete là ~90 ô cùng chạy lại effect + JSON.stringify + setState cho MỖI ký tự.
 * Bộ cũ (InputBase) chặn đúng chỗ này bằng shouldComponentUpdate của AutoCompleteInput.
 */

/** So sánh nông hai object phẳng (dùng cho bảng lỗi của riêng một dòng). */
function shallowEqualObj(a, b) {
	if (a === b) return true;
	if (!a || !b) return false;
	const ka = Object.keys(a), kb = Object.keys(b);
	if (ka.length !== kb.length) return false;
	return ka.every(k => a[k] === b[k]);
}

/**
 * true = props KHÔNG đổi -> React bỏ qua, dòng không vẽ lại.
 *
 * Quy tắc: dòng chỉ vẽ lại khi CHÍNH NÓ đổi (dữ liệu dòng, lỗi của dòng, đang-sửa hay không, cấu hình
 * cột). Riêng `masterData` chỉ được tính đến khi lưới CÓ script đọc dữ liệu chứng từ mẹ
 * (`dependsOnMaster`) — nếu không thì đổi master không ảnh hưởng gì tới cách vẽ dòng.
 */
function areRowPropsEqual(prev, next) {
	if (prev.item !== next.item) return false;
	if (prev.idx !== next.idx) return false;
	if (prev.isActive !== next.isActive) return false;
	if (prev.focusField !== next.focusField) return false;
	if (prev.isReadOnly !== next.isReadOnly) return false;
	if (prev.isLast !== next.isLast) return false;
	if (prev.visibleColumns !== next.visibleColumns) return false;
	if (prev.subFields !== next.subFields) return false;
	if (prev.cellFields !== next.cellFields) return false;
	if (!shallowEqualObj(prev.rowErrors, next.rowErrors)) return false;
	if (next.dependsOnMaster && prev.masterData !== next.masterData) return false;
	return true;
}

/** Lưới có script nào đọc dữ liệu chứng từ mẹ không? (quyết định masterData có nằm trong luật trên) */
function gridDependsOnMaster(subFields) {
	return (subFields || []).some(f => f && (
		typeof f.apiConditionFn === 'function' || typeof f.hideInForm === 'function' ||
		typeof f.readOnly === 'function' || typeof f.helpText === 'function'
	));
}

export { shallowEqualObj, areRowPropsEqual, gridDependsOnMaster };
